<template>
  <div>
    <header-service v-if="!isWebView()"></header-service>
    <router-view class="header-fixed"></router-view>
    <div class="container _textright">
      <btn-pagetop></btn-pagetop>
    </div>
    <footer-service></footer-service>
  </div>
</template>

<script>
import { isWebView } from "@/utils/UserAgent";
import { setSctvTag } from "@/utils/ExternalScripts";
import BtnPagetop from "@/components/button/BtnPagetop";
import HeaderService from "@/components/globals/HeaderService";
import FooterService from "@/components/globals/FooterService";

export default {
  name: "ServiceLayout",
  components: {
    BtnPagetop,
    HeaderService,
    FooterService,
  },
  mounted: function () {
    if (
      !window.__PRERENDER_INJECTED ||
      !window.__PRERENDER_INJECTED.isPrerendering
    ) {
      this.$gtm.enable(true);
      setSctvTag(this.$route.name);
    }
  },
  updated: function () {
    if (
      !window.__PRERENDER_INJECTED ||
      !window.__PRERENDER_INJECTED.isPrerendering
    ) {
      setSctvTag(this.$route.name);
    }
  },
  methods: {
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style scoped></style>
